import { getIOPort, getImageBinding, makeNode } from '../../utils';
import breakerImage from 'unitData/Breaker/breaker.png';
import * as go from 'gojs';

const BreakerTemplate = makeNode(
  getImageBinding('', () => breakerImage),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default BreakerTemplate;
